import React from "react";
import each from "lodash/each";
import FilterBox from "./FilterBox";
import FilterSearch from "./FilterSearch";
import { gettext } from "../../adapter";

const Filter = ({ filters }) => {
  const f = [];
  each(filters, function (filterItems, filterGroup) {
    if (filterItems.length > 1) {
      f.push(<FilterBox filter={filterItems} key={filterGroup} title={filterGroup} />);
    }
  });

  return (
    <div className="panel" id="js-filter-panel">
      <h2>{gettext("Quick filter")}</h2>
      <FilterSearch />
      {f}
    </div>
  );
};

export default Filter;
